// extracted by mini-css-extract-plugin
export default {"video-card-buttons":"yvFeo"};